import React from 'react';
import { Spinner } from './Spinner/Spinner';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { BsSliders } from 'react-icons/bs';
import { MdWarning } from 'react-icons/md';
import { ConfigurationFieldStatus } from '@ydistri/utils';

export enum OverwrittenIcon {
  SLIDERS = 'sliders',
  WARNING = 'warning',
}

const overwrittenIcons: Record<OverwrittenIcon, React.ReactNode> = {
  [OverwrittenIcon.SLIDERS]: <BsSliders />,
  [OverwrittenIcon.WARNING]: <MdWarning />,
};

export const getIconBasedOnStatusAndOverwrite = (
  status: ConfigurationFieldStatus,
  overwritten: boolean,
  overwrittenIcon: OverwrittenIcon | null = OverwrittenIcon.SLIDERS,
): React.ReactNode => {
  switch (status) {
    case ConfigurationFieldStatus.SUCCESS:
      if (overwritten) {
        if (overwrittenIcon) {
          return overwrittenIcons[overwrittenIcon];
        }
      } else {
        return <AiOutlineCheck />;
      }
      break;
    case ConfigurationFieldStatus.ERROR:
      return <AiOutlineClose />;
    case ConfigurationFieldStatus.LOADING:
      return <Spinner />;
    case ConfigurationFieldStatus.DEFAULT:
      if (overwritten) {
        if (overwrittenIcon) {
          return overwrittenIcons[overwrittenIcon];
        }
      }
      break;
  }
};
